import { Box, Stack, Typography, useTheme } from "@mui/material";
import androidResourceAppQr from "assets/images/androidResourceAppQr.png";
import iosResourceAppQr from "assets/images/iosResourceAppQr.png";
import { useState } from "react";
import androidLogo from "./assets/images/androidLogo.webp";
import appleLogo from "./assets/images/appleLogo.webp";
import appsForMspPreview from "./assets/images/appsForMspPreview.webp";
import { DownloadDrawerAccordion } from "./DownloadDrawerAccordion";
import { QrCodeComponent } from "./QrCodeComponent";

export const AppsForMsp = () => {
  const theme = useTheme();
  const [currentAccordionIndex, setCurrentAccordionIndex] = useState(-1);
  const CHANNELS = [
    {
      logo: androidLogo,
      title: "Android",
      content: <QrCodeComponent qrCode={androidResourceAppQr} />,
    },
    {
      logo: appleLogo,
      title: "iOS",
      content: <QrCodeComponent qrCode={iosResourceAppQr} />,
    },
  ];
  return (
    <Stack p="24px" gap="16px">
      <Typography variant="h6">Mobile App for MSP Techs</Typography>
      <Stack
        p="16px 16px 0 16px"
        gap="10px"
        bgcolor={theme.palette.secondary["purple-tint-3"]}
        alignItems={"start"}
      >
        {/* <Stack
          bgcolor={theme.palette.primary.main}
          border={`1px solid ${theme.palette.secondary["purple-tint"]}`}
          borderRadius={"6px"}
          p="4px 16px"
        >
          <Typography variant="body-xsmall" color="darkBg.main">
            Coming Soon
          </Typography>
        </Stack> */}
        <Stack alignSelf={"center"}>
          <img
            style={{ width: "196px", aspectRatio: 1 }}
            src={appsForMspPreview}
            alt="apps for msp preview"
          />
        </Stack>
      </Stack>
      <Box sx={{ overflowY: "scroll", flexGrow: 1 }}>
        {CHANNELS.map(({ logo, title, content }, index) => (
          <DownloadDrawerAccordion
            key={title}
            logo={logo}
            title={title}
            content={content}
            expanded={currentAccordionIndex === index}
            onChange={(expanded) =>
              setCurrentAccordionIndex(expanded ? index : -1)
            }
          />
        ))}
      </Box>
    </Stack>
  );
};
